var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-template"},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"12","sm":"12"}},[_c('Alert')],1)],1),_vm._t("form-body")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }